<div class="container-fluid">
    <div class="d-flex justify-content-between align-items-center mb-4">
        <h4 id="upper">PAI</h4>


    </div>
    <div class="d-flex justify-content-end">
        <div class="me-3">
            <label class="d-inline-flex align-items-center">
                Début:
                <input [(ngModel)]="dateDebut" type="date" class="form-control ms-2" name="dateDebut">
            </label>
        </div>

        <div class="me-3">
            <label class="d-inline-flex align-items-center">
                Fin:
                <input [(ngModel)]=dateFin type="date" class="form-control ms-2" name="dateFin">
            </label>
        </div>

        <div id="tickets-table_filter" class="dataTables_filter me-3">
            <input (click)="getStatistique()" type="button" value="Rechercher" class="btn btn-primary">
        </div>
        <!-- Bouton Exporter -->
        <div class="dropdown d-inline-block mb-2 me-2" ngbDropdown>
            <button type="button" ngbDropdownToggle class="btn btn-secondary dropdown-toggle" id="dropdownMenuButton"
                aria-haspopup="true" aria-expanded="false">
                Exporter <i class="pi pi-upload" style="font-size: 0.8rem"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu aria-labelledby="dropdownMenuButton">
                <a (click)="exportToDocument('pdf')" class="dropdown-item" href="javascript:void(0);">Au format PDF</a>
                <a (click)="exportToDocument('excel')" class="dropdown-item" href="javascript:void(0);">Au format
                    Excel</a>
            </div>
        </div>


        <div class="mb-2 me-2">
            <button routerLink="/suivi/edition/pai" type="button" class="btn btn-primary ">
                <i class="pi pi-arrow-left" style="font-size: 0.8rem"></i> Retour
            </button>
        </div>

    </div>
    <div class="row">

        <!-- Main Content -->
        <div class="col-md-12 p-0">
            <!-- Tableau des activités par année -->
            <div class="card">

                <div class="card-body p-0">
                    <div class="table-container">
                        <div class="table-responsive" id="tepTableContainer">
                            <table class="table table-bordered tep-table">
                                <thead class="thead-light rwd-table">
                                    <tr>
                                        <th style="width:140px">Code</th>
                                        <th>Libellé</th>
                                        <th>Anputation budgétaire</th>
                                        <th class="text-center" style="width:80px">Poids</th>
                                        <th class="text-end" style="width:160px">Montant (FCFA)</th>
                                        <th class="text-end" style="width:160px">FADEC Affecté</th>
                                        <th class="text-center" style="width:130px">Période</th>
                                        <th style="width:120px">Responsable</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngFor="let item of hierarchicalItems">

                                        <!-- PROGRAMME -->
                                        <tr *ngIf="item.type === 'programme'" class="row-programme"
                                            style="cursor:pointer" (click)="toggleProgramme(item.id)">
                                            <td>
                                                <i class="pi me-2 toggle-icon"
                                                    [class.pi-chevron-down]="isProgrammeOpen(item.id)"
                                                    [class.pi-chevron-right]="!isProgrammeOpen(item.id)"></i>
                                                <span class="badge bg-dark fs-6">{{ item.code }}</span>
                                            </td>
                                            <td class="fw-bold text-uppercase">{{ item.libelle }}</td>
                                            <td>{{item.imputation | formatMoney:null || '-'}}</td>

                                            <td class="text-center"><span class="badge bg-secondary">{{ item.poids
                                                    }}</span></td>
                                            <td class="text-end">—</td>
                                            <td class="text-end">—</td>
                                            <td class="text-center">—</td>
                                            <td>—</td>
                                        </tr>

                                        <!-- ACTION — visible si son programme parent est ouvert -->
                                        <tr *ngIf="item.type === 'action' && isProgrammeOpen(item.parent_id)"
                                            class="row-action" style="cursor:pointer" (click)="toggleAction(item.id)">
                                            <td class="ps-3">
                                                <i class="pi me-1 toggle-icon text-primary"
                                                    [class.pi-chevron-down]="isActionOpen(item.id)"
                                                    [class.pi-chevron-right]="!isActionOpen(item.id)"></i>
                                                <span class="badge bg-primary">{{ item.code }}</span>
                                            </td>
                                            <td class="fw-semibold ps-2">{{ item.libelle }}</td>
                                            
                                            <td>{{item.imputation | formatMoney:null || '-'}}</td>
                                            <td class="text-center"><span class="badge bg-info text-dark">{{ item.poids
                                                    }}</span></td>
                                            <td class="text-end">—</td>
                                            <td class="text-end">—</td>
                                            <td class="text-center">—</td>
                                            <td>—</td>
                                        </tr>

                                        <!-- ACTIVITE — visible si son action parente est ouverte -->
                                        <tr *ngIf="item.type === 'activite' && isActiviteVisible(item)"
                                            class="row-activite" style="cursor:pointer"
                                            (click)="toggleActivite(item.id)">
                                            <td class="ps-4">
                                                <i class="pi me-1 toggle-icon text-success"
                                                    [class.pi-chevron-down]="isActiviteOpen(item.id)"
                                                    [class.pi-chevron-right]="!isActiviteOpen(item.id)"></i>
                                                <span class="badge bg-success">{{ item.code }}</span>
                                            </td>
                                            <td class="ps-2">
                                                <i class="pi pi-angle-double-right text-success me-1"></i>{{
                                                item.libelle }}
                                            </td>
                                            <td>{{item.imputation | formatMoney:null || '-'}}</td>
                                            <td class="text-center"><span class="badge bg-warning text-dark">{{
                                                    item.poids }}</span></td>
                                            <td class="text-end montant">{{ item.montant | number:'1.0-0' }}</td>
                                            <td class="text-end montant">{{ item.fadec_affecte | number:'1.0-0' }}</td>
                                            <td class="text-center small">
                                                <span *ngIf="item.date_debut">{{ item.date_debut | date:'dd/MM/yy'
                                                    }}</span>
                                                <span *ngIf="item.date_fin"> → {{ item.date_fin | date:'dd/MM/yy'
                                                    }}</span>
                                            </td>
                                            <td><span class="badge bg-light text-dark border">{{ item.responsable
                                                    }}</span></td>
                                        </tr>

                                        <!-- TACHE — visible si son activité parente est ouverte -->
                                        <tr *ngIf="item.type === 'tache' && isTacheVisible(item)" class="row-tache">
                                            <td class="ps-5">
                                                <span class="badge bg-secondary">{{ item.code }}</span>
                                            </td>
                                            <td class="ps-3 text-muted small">
                                                <i class="pi pi-minus me-1"></i>{{ item.libelle }}
                                            </td>
                                            <td>{{item.imputation | formatMoney:null || '-'}}</td>
                                            <td class="text-center"><span class="badge bg-light text-dark border">{{
                                                    item.poids }}</span></td>
                                            <td class="text-end">—</td>
                                            <td class="text-end">—</td>
                                            <td class="text-center small text-muted">
                                                <span *ngIf="item.date_debut">{{ item.date_debut | date:'dd/MM/yy'
                                                    }}</span>
                                                <span *ngIf="item.date_fin"> → {{ item.date_fin | date:'dd/MM/yy'
                                                    }}</span>
                                            </td>
                                            <td class="small text-muted">{{ item.responsable }}</td>
                                        </tr>

                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                        <div *ngIf="items.length === 0" class="text-center py-5 text-muted">
                            <i class="pi pi-inbox" style="font-size:2rem"></i>
                            <p class="mt-2">Aucune donnée. Veuillez lancer une recherche.</p>
                        </div>
                    </div>
                    <div class="p-3 border-top">
                        <!-- <p-paginator [rows]="rowsProjets" [totalRecords]="totalRecords" [first]="firstProjets"
                            (onPageChange)="onPageChangeProjets($event)" [rowsPerPageOptions]="[10, 25, 50]">
                        </p-paginator> -->
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<p-toast />
<ngx-ui-loader></ngx-ui-loader>